export default {"src":"/_next/static/media/clock_24.8113d010.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};